import React, { Component } from "react";
import { Button, Alert, Spin } from "antd";
import PropTypes from "prop-types";

import {
  EmailVerificationInfo,
  FormContainer,
  ContactUsLink,
  EmailVerificationReason,
  EmailInstructions
} from "../../components";

class VerifyEmail extends Component {
  state = {
    verification: {
      processing: false,
      error: false,
      errorMsg: "",
      data: null
    }
  };

  sendVerificationEmail = () => {
    const { appsAPI } = this.props;

    const self = this;

    self.setState(
      prevState => ({
        verification: {
          ...prevState.verification,
          processing: true
        }
      }),
      () =>
        appsAPI
          .get("/verifyemailbytoken")
          .then(function(response) {
            self.setState(prevState => ({
              verification: {
                ...prevState.verification,
                processing: false,
                data: response.data
              }
            }));
          })
          .catch(error => {
            console.log(
              "Error occurred while sending verification email",
              error
            );
            self.setState(prevState => ({
              verification: {
                ...prevState.verification,
                processing: false,
                error: true,
                errorMsg: error.message
              }
            }));
          })
    );
  };

  render() {
    const { verification } = this.state;
    return (
      <FormContainer formTitle={"Verify email"}>
        <div style={{ textAlign: "center" }}>
          <Spin spinning={verification.processing}>
            <EmailVerificationInfo appsAPI={this.props.appsAPI} />
            <Button
              type="primary"
              icon="mail"
              onClick={this.sendVerificationEmail}
              style={{ marginBottom: "8px" }}
              disabled={verification.data}
            >
              Send verification email
            </Button>
          </Spin>
        </div>
        {verification.error && (
          <Alert type={"warning"} showIcon message={verification.errorMsg} />
        )}
        {verification.data && (
          <Alert type={"success"} showIcon message={<EmailInstructions />} />
        )}

        <EmailVerificationReason
          style={{ textAlign: "right", margin: "8px 0" }}
        />
        <ContactUsLink />
      </FormContainer>
    );
  }
}

VerifyEmail.propTypes = {
  appsAPI: PropTypes.func.isRequired
};

export default VerifyEmail;



// WEBPACK FOOTER //
// ./src/views/verify_email/VerifyEmail.jsx